import { atom, useAtom } from 'jotai';
import { applyLanguage, defaultLanguage } from '../internationalization';
import type { Language } from '../internationalization/language';

type UseLanguage = {
  language: Language;
  changeLanguage: (language: Language) => void;
};

const languageAtom = atom<Language>(defaultLanguage);

const useLanguage = (): UseLanguage => {
  const [language, setLanguage] = useAtom(languageAtom);

  const changeLanguage = (language: Language): void => {
    setLanguage(language);
    applyLanguage(language);
  };

  return { language, changeLanguage };
};

export { useLanguage };
